module.exports = __webpack_public_path__ + "img/Poorter_hotel-257.426ea66d.jpg";